import { render } from "./TemplatesIndex.vue?vue&type=template&id=27286089&scoped=true"
import script from "./TemplatesIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplatesIndex.vue?vue&type=script&setup=true&lang=js"

import "./TemplatesIndex.vue?vue&type=style&index=0&id=27286089&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27286089"],['__file',"resources/js/modules/email/components/TemplatesIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27286089"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27286089', __exports__)) {
    api.reload('27286089', __exports__)
  }
  
  module.hot.accept("./TemplatesIndex.vue?vue&type=template&id=27286089&scoped=true", () => {
    api.rerender('27286089', render)
  })

}


export default __exports__